import React, { memo, useState } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { EVENT_SOURCE } from 'Pods/SearchPage/Shared/Tracking/constants'
import { FilterTrackingProvider } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

import PolyCount from './Components/PolyCount/PolyCount'
import PrintAttributes from './Components/PrintAttributes/PrintAttributes'
import Style from './Components/Style/Style'
import TechnicalAttributes from './Components/TechnicalAttributes/TechnicalAttributes'

// Contextual bar shown when an asset type is selected; hidden below 960 (CSS-driven), where the
// same filters live in the More filters drawer.
function SecondaryFilters() {
  const translate = useTranslate()

  const assetType = useSearchPageStore(state => state.assetType)
  // Animate only a client-side tab switch; the server-rendered row must not fade in on page load.
  const [prevAssetType, setPrevAssetType] = useState(assetType)
  const [hasSwitched, setHasSwitched] = useState(false)
  if (assetType !== prevAssetType) {
    setPrevAssetType(assetType)
    setHasSwitched(true)
  }

  if (assetType === ASSET_TYPE.ALL) return null

  const is3DOnly = assetType === ASSET_TYPE.THREE_D_ONLY

  return (
    <FilterTrackingProvider eventSource={EVENT_SOURCE.SECONDARY_BAR}>
      <div
        className="secondary-filters"
        role="group"
        aria-label={translate('search_page.filters.secondary.group_label')}
      >
        {/* Keyed on the asset type so a tab switch remounts the row and replays the entry animation. */}
        <div
          key={assetType}
          className={classnames('secondary-filters__left', hasSwitched && 'secondary-filters__left--animated')}
        >
          <Style />
          {is3DOnly ? (
            <>
              <PolyCount />
              <TechnicalAttributes />
            </>
          ) : (
            <PrintAttributes />
          )}
        </div>
      </div>
    </FilterTrackingProvider>
  )
}

export default memo(SecondaryFilters)
